import { Component, OnInit, Input } from '@angular/core';
declare var $:any;
declare var Circles:any;
@Component({
  selector: 'app-circles',
  templateUrl: './circles.component.html',
  styleUrls: ['./circles.component.scss']
})
export class CirclesComponent implements OnInit {
random: string = '_' + Math.random().toString(36).substr(2, 9);
 @Input() percentage!: string;
@Input() color: any;
  constructor() { }

  ngOnInit() {
  }
ngAfterViewInit() {

Circles.create({
                            id: this.random,
                            value: this.percentage,
                            radius: 80,
                            width: 15,
                            colors: this.color,
                            maxValue:     100,                          
                            text:         function(value:any){return value + '%';}, 
                            duration:     400,
                            wrpClass:     'circles-wrp',
                            textClass:    'circles-text',
                            styleWrapper: true,
                            styleText:    true,
                        });
}
}
